/* eslint-disable import/prefer-default-export */
export const IP_POOL_TYPES = {
  POOL_MAILS_OPERACIONALES: 'Pool mails operacionales',
  POOL_MAILS_MASIVOS: 'Pool mails masivos',
  POOL_MAILS_KOBROS: 'Pool mails kobros',
};
